<template>
  <div class="products">
    <b-modal :active.sync="showEditModal" has-modal-card>
      <div class="modal-card" v-if="editProduct">
        <header class="modal-card-head">
          <h1 class="title is-4">{{ editProduct.id ? 'Edit' : 'Add'}} Product</h1>
        </header>
        <section class="modal-card-body has-text-center">
          <b class="capitalize">Name</b>
          <b-input v-model="editProduct.name" />
        </section>
        <footer class="modal-card-foot">
          <template v-if="!showConfirmDelete">
            <button class="button is-small" type="button" @click="closeEdit">Cancel</button>
            <button class="button is-small is-success" @click="submitEdit">{{ editProduct.id ? 'Update' : 'Add'}}</button>
            <button v-if="editProduct.id" class="button is-small is-danger" @click="showConfirmDelete = true">Delete</button>
          </template>
          <template v-else>
            <button class="button is-small is-warning" @click="deleteProduct">Confirm Delete Product</button>
            <button class="button is-small" type="button" @click="showConfirmDelete = false">Cancel</button>
          </template>
        </footer>
      </div>
    </b-modal>

    <div class="pad">
      <b-message type="is-danger" v-if="errMsg.length">{{ errMsg }}</b-message>
    </div>

    <div class="pad-left pad-right flex">
        <b-field label="" :custom-class="sizeClass">
          <b-input type="search" placeholder="Search" v-model="filterStr" :size="sizeClass" />
        </b-field>
        <div class="flex-1"></div>
        <button style="margin-left: 50px;" class="button is-success is-small" @click="add()">Add Product</button>
    </div>

    <table class="table is-hoverable is-fullwidth" style="border-top: solid 2px #ccc;">
      <tbody>
        <tr v-for="p of filteredProducts" :key="p.id">
          <td colspan="2">{{ p.name }}</td>
          <td class="has-text-right">
            <button class="button is-small" @click="edit(p)">
              <font-awesome-icon icon="edit" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Products',
  data () {
    return {
      products: [],
      errMsg: '',
      filterStr: '',
      showEditModal: false,
      editProduct: null,
      errMsgTimer: null,
      showConfirmDelete: false,
      sizeClass: 'is-small'
    }
  },
  computed: {
    filteredProducts () {
      let str = this.filterStr.toLowerCase().trim()
      return this.products
        .filter(p => p.name.toLowerCase().indexOf(str) >= 0)
        .sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  watch: {
    errMsg () {
      clearTimeout(this.errMsgTimer)
      if (this.errMsg.length) {
        this.errMsgTimer = setTimeout(() => { this.errMsg = '' }, 3000)
      }
    }
  },
  created () {
    this.$api('getProducts')
      .then(resp => {
        this.products = resp.data
      })
      .catch(err => {
        this.errMsg = err.toString()
      })
  },
  methods: {
    add () {
      this.editProduct = { name: '' }
      this.showEditModal = true
    },
    edit (product) {
      this.editProduct = JSON.parse(JSON.stringify(product))
      this.showConfirmDelete = false
      this.showEditModal = true
    },
    submitEdit () {
      if (this.editProduct.id) {
        this.$api('updateProduct', this.editProduct)
          .then(resp => {
            let i = this.products.findIndex(p => p.id === this.editProduct.id)
            if (i >= 0) {
              this.$set(this.products, i, this.editProduct)
            }
            this.closeEdit()
          })
          .catch(err => {
            this.errMsg = err.toString()
            this.closeEdit()
          })
      } else {
        this.$api('addProduct', this.editProduct)
          .then(resp => {
            this.products.push(resp.data)
            this.closeEdit()
          })
          .catch(err => {
            this.errMsg = err.toString()
            this.closeEdit()
          })
      }
    },
    deleteProduct () {
      this.$api('deleteProduct', { id: this.editProduct.id })
        .then(resp => {
          let i = this.products.findIndex(p => p.id === this.editProduct.id)
          if (i >= 0) {
            this.products.splice(i, 1)
            this.closeEdit()
          }
        })
        .catch(err => {
          this.errMsg = err.toString()
          this.closeEdit()
        })
    },
    closeEdit () {
      this.showEditModal = false
      this.editProduct = null
    }
  }
}
</script>

<style>
  .products .modal-card-head,
  .products .modal-card-body,
  .products .modal-card-foot {
    min-width: 400px;
  }

  .products table  tbody tr:nth-child(odd) td {
    background-color: #fafafa;
  }
</style>
